"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const mapStateToProps = (stores) => ({
    isMobile: stores.UiStore.isMobile
});
const Content = ({ children, className, isMobile }) => {
    const onClick = (event) => {
        if (isMobile) {
            event.stopPropagation();
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { slot: "collapsed", onClick: onClick, className: className, children: children }));
};
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(Content);
